import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';
import { CommonMessages } from 'src/app/shared/messages/messages.enum';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-list-subscription-feature-assign',
  templateUrl: './list-subscription-feature-assign.component.html',
  styleUrls: ['./list-subscription-feature-assign.component.css']
})
export class ListSubscriptionFeatureAssignComponent extends BaseComponent implements OnInit {

  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  companyID = 0;
  selectedCompany: any = '';
  selectedSub: any = '';
  selectedStatus: any = '';
  subsObj: any = [];
  currentUser;
  getCompanyobj: any = [];
  limitObj: any = [];
  limitTotal: number = 0;
  slCatPage = 1;
  slCatLimit = 10;
  slCatSkip = 0;
  slCatord = "desc";
  slCatColname = "v.id";
  constructor(
    private clientService: ClientService,
    private masterService: MasterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;
      this.selectedCompany = this.companyID;
      this.loadSubscriptions();
      this.getAssignList();
    }
    if (this.currentUser.admin_customer_id == '0') this.getCompany();
  }
  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      const working = this.bindWorkingCompany(this.getCompanyobj);
      if (working) {
        this.selectedCompany = working;
        this.loadSubscriptions();
        this.getAssignList();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }
  onCompanyChange(value?: any) {
    if (value !== undefined) {
      this.selectedCompany = value;
    }
    this.selectedSub = '';
    this.slCatPage = 1;
    this.loadSubscriptions();
    this.getAssignList();
  }
  onSubChange(value?: any) {
    if (value !== undefined) {
      this.selectedSub = value;
    }
    this.slCatPage = 1;
    if (this.selectedSub) {
      this.slCatColname = "f.order_no";
      this.slCatord = "asc";
    }
    this.getAssignList();
  }
  onStatusChange(value?: any) {
    if (value !== undefined) {
      this.selectedStatus = value;
    }
    this.slCatPage = 1;
    this.getAssignList();
  }
  resetFilters() {
    this.selectedSub = '';
    this.selectedStatus = '';
    this.slCatPage = 1;
    this.slCatSkip = 0;
    this.slCatColname = 'v.id';
    this.slCatord = 'desc';
    if (this.searchText && this.searchText.nativeElement) {
      this.searchText.nativeElement.value = '';
    }
    if (this.companyID == 0) {
      this.selectedCompany = this.bindWorkingCompany(this.getCompanyobj);
      if (this.selectedCompany) {
        this.loadSubscriptions();
        this.getAssignList();
      } else {
        this.subsObj = [];
        this.limitObj = [];
        this.limitTotal = 0;
      }
      return;
    }
    this.getAssignList();
  }
  isFeatureTrue(value: any) {
    const v = String(value == null ? '' : value).trim().toLowerCase();
    return v === 'true' || v === 'yes' || v === '1' || v === 't' || v === 'active';
  }
  isFeatureFalse(value: any) {
    const v = String(value == null ? '' : value).trim().toLowerCase();
    return v === 'false' || v === 'no' || v === '0' || v === 'f' || v === 'inactive' || v === 'off' || v === '';
  }
  loadSubscriptions() {
    this.subsObj = [];
    if (!this.selectedCompany) {
      return;
    }
    this.masterService.getSubscriptionListDropdown(this.selectedCompany, 1000, 0).subscribe(data => {
      if (data.status && data.data && data.data.rows) {
        this.subsObj = data.data.rows;
      } else {
        this.subsObj = [];
      }
    }, error => {
      console.log(error);
      this.subsObj = [];
    });
  }
  getAssignList() {
    let searchTerm = this.searchText.nativeElement.value;
    this.slCatSkip = (this.slCatPage - 1) * this.slCatLimit;

    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();

      this.masterService.getSubscriptionFeatureValueList(this.selectedCompany, this.slCatLimit, this.slCatSkip, searchTerm, this.slCatColname, this.slCatord, this.selectedSub, this.selectedStatus).subscribe(data => {
        this.ngxSpinnerService.hide();
        if (data.status) {
          if (data.data.rows == null) { this.limitObj = [] }
          else { this.limitObj = data.data.rows }
          this.limitTotal = data.data.total;
        } else {
          this.limitObj = [];
          this.limitTotal = 0;
        }
      }, error => { console.log(error); this.ngxSpinnerService.hide(); });
    } else {
      this.limitObj = [];
      this.selectedCompany = "";
      this.limitTotal = 0;
      this.ngxSpinnerService.hide();
    }
  }
  setOrder(value: string) {
    this.slCatColname = value
    if (this.slCatord == 'asc') {
      this.slCatord = 'desc'
    } else {
      this.slCatord = 'asc'
    } this.getAssignList()
  }
  editPost(id: any) {
    localStorage.setItem("edit_subscription_feature_assign_id", id);
    localStorage.setItem("subscription_feature_assign_edit_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/edit-subscription-feature-assign']);
  }
  delLimit(event: any, id: any) {
    event.preventDefault();
    this.confirmationDialogService.confirm('Please confirm', 'ARE YOU SURE YOU WANT TO DELETE ?', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.deleteSubscriptionFeatureValue(this.selectedCompany, id).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Feature assignment deleted successfully");
              this.getAssignList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  updateStatus(event: any, id: any, status: any) {
    event.preventDefault();
    let obj = {
      isactive: (status == true) ? false : true,
    }
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To' + ((obj.isactive) ? ' Active?' : ' In Active?'), 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.updateSubscriptionFeatureValueStatus(this.selectedCompany, id, obj).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Status Updated Successfully");
              this.getAssignList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    this.ngxSpinnerService.show();
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.slCatSkip = 0;
          this.slCatPage = 1;
        }),
        switchMap(data => this.masterService.getSubscriptionFeatureValueList(this.selectedCompany, this.slCatLimit, this.slCatSkip, this.searchText.nativeElement.value, this.slCatColname, this.slCatord, this.selectedSub, this.selectedStatus))
      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.limitObj = [] }
          else { this.limitObj = res.data.rows }
          this.limitTotal = res.data.total;
        } else {
          this.limitObj = [];
          this.limitTotal = 0;
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.limitObj = [];
        this.limitTotal = 0;
        this.ngxSpinnerService.hide();
      });
  }
}
